import aampeTheme from '../constants/aampeTheme'

export default function getRandom(arr, n) {
    if (!arr || !arr.length) return []
    var result = new Array(n),
        len = arr.length,
        taken = new Array(len)
    if (n > len) n = len
    while (n--) {
        var x = Math.floor(Math.random() * len)
        result[n] = arr[x in taken ? taken[x] : x]
        taken[x] = --len in taken ? taken[len] : len
    }
    return result
}

export const getCategoricalColors = (numberOfColors) => {
    const baseColors = Object.values(aampeTheme.dataVizColors)
    const numberOfBaseColors = baseColors.length
    if (numberOfColors < numberOfBaseColors) {
        return baseColors
    }
    return Array.from(Array(numberOfColors)).map((v, index) => {
        const position =
            ((numberOfBaseColors - 1) / (numberOfColors - 1)) * index
        if (position === numberOfBaseColors - 1) {
            return baseColors[numberOfBaseColors - 1]
        }
        const floorColorIndex = Math.floor(position)
        return blendColors(
            baseColors[floorColorIndex],
            baseColors[floorColorIndex + 1],
            position - floorColorIndex,
        )
    })
}

/**
 *
 * @param colorA: left edge of the color spectrum in hex code
 * @param colorB: right edge of the color spectrum in hex code
 * @param amount: it should be 0 to 1, with 0 being exactly colorA,
 * 1 being exactly colorB, and 0.5 being the "midpoint".
 *
 * returns the blended color in hex code
 */
const blendColors = (colorA, colorB, amount) => {
    const [rA, gA, bA] = colorA.match(/\w\w/g).map((c) => parseInt(c, 16))
    const [rB, gB, bB] = colorB.match(/\w\w/g).map((c) => parseInt(c, 16))
    const r = Math.round(rA + (rB - rA) * amount)
        .toString(16)
        .padStart(2, '0')
    const g = Math.round(gA + (gB - gA) * amount)
        .toString(16)
        .padStart(2, '0')
    const b = Math.round(bA + (bB - bA) * amount)
        .toString(16)
        .padStart(2, '0')
    return '#' + r + g + b
}

export function hexToRgba(hex, alpha) {
    let c = hex.replace('#', '')

    if (c.length === 3) {
        c = c
            .split('')
            .map((char) => char + char)
            .join('')
    }

    const bigint = parseInt(c, 16)
    const r = (bigint >> 16) & 255
    const g = (bigint >> 8) & 255
    const b = bigint & 255

    return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
